import React from 'react'
import { useHistory } from 'react-router-dom'
import OpenInNewTabIcon from 'transfix-icons/build/OpenInNewTabIcon'
import { Box, Typography, createStyles, makeStyles, Button } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'
import { ParserVersion } from '../../EdiSelfService/types'
import { EDI_TOOLS_ROUTES } from '../../LandingPage'

interface IParserDetailsProps {
  liveParserVersion: ParserVersion | undefined
}

const useParserDetailsStyles = makeStyles(() =>
  createStyles({
    contentBox: {
      display: 'row',
      alignItems: 'center',
      pl: 2,
      pr: 2,
      paddingLeft: 10,
      paddingBottom: 20,
    },
    header: {
      color: brandColors.coolGray5,
    },
  })
)

export const ParserDetails = ({ liveParserVersion }: IParserDetailsProps) => {
  const history = useHistory()
  const classes = useParserDetailsStyles()

  const handleParserPageClick = () => {
    history.push(`${EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND}/parser-version/${liveParserVersion?.id}`)
  }

  return (
    <Box mb={3}>
      <div className={classes.contentBox}>
        <Button
          startIcon={<OpenInNewTabIcon size='large' />}
          variant='contained'
          color='primary'
          onClick={handleParserPageClick}>
          Parser Page
        </Button>
      </div>
      <Box className={classes.contentBox}>
        <Typography className={classes.header}>Active Version Id</Typography>
        <Typography>{liveParserVersion?.id}</Typography>
      </Box>
      <Box className={classes.contentBox}>
        <Typography className={classes.header}>Notes</Typography>
        <Typography>{liveParserVersion?.notes}</Typography>
      </Box>
      <Box className={classes.contentBox}>
        <Typography className={classes.header}>Parser Library</Typography>
        <Typography>{liveParserVersion?.parser_library}</Typography>
      </Box>
    </Box>
  )
}
